import { render, staticRenderFns } from "./CustomersEdit.vue?vue&type=template&id=2d9e2be3&v-bind%3Avalue=value&v-on%3Ainput=%24emit('input'%2C%20%24event.target.value)"
import script from "./CustomersEdit.vue?vue&type=script&lang=js"
export * from "./CustomersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports